var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { translate, useToastService } from '@lucidlink/uicore';
import { workspaceRoutes } from '#services';
import { ADD_WORKSPACE_WS_NAME_NOT_FOUND_ERROR, ADD_WORKSPACE_WS_NO_SSO_CONFIGURED_ERROR, WorkspaceNameNotFoundError, WorkspaceSsoNotConfiguredError, } from '../../errors';
import { useAddWorkspaceForm, useAddWorkspaceSsoLogin, } from './hooks';
export const useAddWorkspaceModal = ({ closeModal }) => {
    _react_refresh_temp_1();
    const navigate = useNavigate();
    const { addToast } = useToastService();
    const { formData, injectErrors, isSubmitDisabled } = useAddWorkspaceForm();
    const onSuccess = useCallback(({ workspaceId }) => {
        closeModal();
        void navigate(workspaceRoutes.workspace(workspaceId));
    }, [closeModal, navigate]);
    const onError = useCallback((error) => {
        if (error instanceof WorkspaceNameNotFoundError) {
            injectErrors({
                workspaceName: {
                    errors: [ADD_WORKSPACE_WS_NAME_NOT_FOUND_ERROR],
                },
            });
            return;
        }
        if (error instanceof WorkspaceSsoNotConfiguredError) {
            injectErrors({
                workspaceName: {
                    errors: [ADD_WORKSPACE_WS_NO_SSO_CONFIGURED_ERROR],
                },
            });
            return;
        }
        addToast({
            'data-testid': 'add-workspace-generic-error',
            content: {
                message: translate('An error occurred while trying to log in to the workspace. Please try again.'),
            },
            kind: 'negative',
        });
    }, [addToast, injectErrors]);
    const { startSsoLoginMutation: { isPending: isPendingStartSsoLogin, mutate: startSsoLogin, }, } = useAddWorkspaceSsoLogin({
        onSuccess,
        onError,
    });
    const onSubmit = useCallback(() => {
        if (isSubmitDisabled || isPendingStartSsoLogin) {
            return;
        }
        const { workspaceName } = formData;
        if (!workspaceName) {
            return;
        }
        startSsoLogin(workspaceName);
    }, [formData, isPendingStartSsoLogin, isSubmitDisabled, startSsoLogin]);
    return {
        isPendingStartSsoLogin,
        isSubmitDisabled,
        onSubmit,
    };
};
_react_refresh_temp_1(useAddWorkspaceModal, "nDnA9KWTp2ym4zSTfSgGeOFBbQE=", false, () => [useNavigate, useToastService, useAddWorkspaceForm, useAddWorkspaceSsoLogin]);
